import { makeAutoObservable } from "mobx";
import { FullOverlayModalsControl } from "./FullOverlayModalsControl";

class UserPanelSettingStore {
  modal: FullOverlayModalsControl = new FullOverlayModalsControl();
  constructor() {
    makeAutoObservable(this);
  }
}
export const userPanelSettingStore = new UserPanelSettingStore();
